import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

import {
  AlertStatusStruct,
  ALERT_STATUS_TO_COLOR_SCHEME,
  ColorSchemeStruct,
} from '../types';
import { fontSizes } from 'packages/common-frontend/theme/typography';
import { size } from 'packages/common-frontend/theme/utils';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(alertAnatomy.keys);

const SubtleVariant = definePartsStyle((props) => {
  const status = AlertStatusStruct.parse(props.status);
  const colorScheme = props.colorScheme
    ? ColorSchemeStruct.parse(props.colorScheme)
    : ALERT_STATUS_TO_COLOR_SCHEME[status];

  const fontSize = size({
    sm: fontSizes.sm.fontSize,
    md: fontSizes.base.fontSize,
    lg: fontSizes.lg.fontSize,
  })(props);
  const lineHeight = size({
    sm: fontSizes.sm.lineHeight,
    md: fontSizes.base.lineHeight,
    lg: fontSizes.lg.lineHeight,
  })(props);

  return {
    container: {
      background: mode(`${colorScheme}.50`, `${colorScheme}.800`)(props),
      padding: size({ sm: '0.5rem', md: '0.75rem', lg: '1rem' })(props),
      borderRadius: size({ sm: '0.5rem', md: '0.75rem', lg: '1rem' })(props),
      fontSize,
      lineHeight,
    },
    title: { fontSize, lineHeight },
    description: { fontSize, lineHeight },
    icon: {
      alignSelf: 'baseline',
      marginTop: size({ sm: '0.125rem', md: '0.125rem', lg: '0rem' })(props),
      height: size({ sm: '1rem', md: '1.25rem', lg: '1.5rem' })(props),
      width: size({ sm: '1rem', md: '1.25rem', lg: '1.5rem' })(props),
    },
    spinner: {
      alignSelf: 'baseline',
      marginTop: size({ sm: '0.0625rem', md: '0.0625rem', lg: '0rem' })(props),
    },
  };
});

// Exports
export const Alert = defineMultiStyleConfig({
  variants: {
    subtle: SubtleVariant,
    // These variants are not supported
    'left-accent': () => {
      throw Error('Not implemented in Chakra theme');
    },
    'top-accent': () => {
      throw Error('Not implemented in Chakra theme');
    },
  },
});
